/* Schwierigkeitsrechner: Bronze, Silber oder Gold?
   Markup und Texte: snippets/ms-tier-calc.liquid, Styles: snippets/ms-tier-calc-styles.liquid.

   MODELL (nur koerperliche Form; Kopf und Verpflegung stehen als Hinweis im Ergebnis).
   1) Belastung je Tag = (km + hm/100) x Untergrund / Tage der Stufe.
      Untergrund: ROAD 1,0 / GRAVEL 1,25 / MTB 1,5 / TRAIL 1,7. E-Bike: x 0,6.
   2) Kapazitaet je Tag = (1,4 x Wochenstunden + 1,25 x laengste Ausfahrt) x 20 Leistungs-km.
      Gold bekommt +12 %, weil ein einzelner Tag mehr hergibt als mehrere am Stueck.
   3) Hoehenmeter pro Woche: Richtwerte Bronze 800, Silber 1.500, Gold 2.500. Darunter bis
      12 % Abzug; wer 7 Stunden und mehr faehrt, gleicht das weitgehend aus (Flachfahrer).
      Keine Mehrtages-Erfahrung: bis 10 % Abzug bei Bronze und Silber.
   4) "Was suchst du": Meine Grenze hebt um 10 %, Landschaft senkt um 8 %.
   EICHPUNKT (Fabian, 20.09.2026): MTB Silber gut geschafft mit 4 bis 5 Stunden pro Woche,
   laengster Fahrt um 3 Stunden, 1.500 bis 2.000 hm pro Woche, mehrere Tage "schon gemacht".
   Wer 5 bis 8 Stunden trainiert und 6 bis 8 Stunden am Stueck gefahren ist, ist Goldfahrer.

   FUEHRUNG (Runden 28 und 29): Die Fragen werden nacheinander aufgedeckt und starten leer:
   keine Pille gewaehlt, Regler am Anfang. Die erste Beruehrung einer Frage (Pille waehlen,
   Regler bewegen) oeffnet die naechste. Offene Fragen bleiben offen und bedienbar. Das
   Ergebnis rechnet von Anfang an mit und waechst mit jeder Antwort. Vorbelegt ist nur, was
   die Seite schon weiss: die Runde auf der Buchen-Seite, der Antrieb aus der Bike-Wahl. */
(function () {
  'use strict';
  var FACTOR = { road: 1.0, gravel: 1.25, mtb: 1.5, trail: 1.7 };
  var TIER = { bronze: { days: 3, tf: 1, hmw: 800, c: '#a15a2a' }, silber: { days: 2, tf: 1, hmw: 1500, c: '#8f8f8f' }, gold: { days: 1, tf: 1.12, hmw: 2500, c: '#c99a2e' } };
  var MULTI = { a: 0.9, b: 0.96, c: 1 }, WANT = { a: 0.92, b: 1, c: 1.1 }, EBIKE = 0.6;
  var ARROW = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
  var esc = function (s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var fill = function (s, o) { return String(s).replace(/\[(\w+)\]/g, function (m, k) { return o[k] != null ? o[k] : m; }); };

  function mount(host) {
    if (host._msCalc) return host._msCalc;
    var data; try { data = JSON.parse(host.querySelector('[data-ms-calc-data]').textContent); } catch (e) { return null; }
    var root = host.querySelector('[data-ms-calc-root]'), T = data.t, mode = host.getAttribute('data-mode') || 'page', id = 'mscalc-' + (host.getAttribute('data-uid') || 'x');
    var rounds = (data.rounds || []).filter(function (r) { return r && FACTOR[r.k] && r.km > 0 && r.hm > 0; });
    if (!root || !rounds.length) return null;
    var tiers = data.tiers.map(function (t) { var m = TIER[t.k]; return { k: t.k, name: t.name, trip: t.trip, claim: t.claim, days: m.days, tf: m.tf, hmw: m.hmw, c: m.c }; });
    var st = { ch: rounds[0].k, drive: 'a', hours: 0, long: 1, hmw: 0, multi: 'a', want: 'b' }, answered = { ch: true };
    // km und hm am Stueck, ohne Tausenderpunkt (Hoehen nie 1.930 hm)
    var nf = function (n) { return String(Math.round(n)); };
    var hrs = function (h) { return fill(T.hours, { n: (Math.round(h * 2) / 2).toString().replace('.', data.dec || ',') }); };
    var byK = function (k) { return rounds.filter(function (r) { return r.k === k; })[0] || rounds[0]; };

    var pill = function (name, val, label, color) {
      return '<label class="ms-calc__opt"' + (color ? ' style="--mc-oc:color-mix(in srgb, ' + esc(color) + ' 72%, #121416)"' : '') + '><input type="radio" name="' + id + '-' + name + '" id="' + id + '-' + name + '-' + val + '" value="' + val + '"' + (answered[name] && st[name] === val ? ' checked' : '') + '><span>' + esc(label) + '</span></label>';
    };
    var range = function (key, b, rest, min, max, step) {
      return '<div class="ms-calc__q"><label for="' + id + '-' + key + '"><b>' + esc(b) + '</b> ' + esc(rest) + '</label><div class="ms-calc__range"><input type="range" id="' + id + '-' + key + '" name="' + id + '-' + key + '" min="' + min + '" max="' + max + '" step="' + step + '" value="' + st[key] + '"><output for="' + id + '-' + key + '" data-o="' + key + '"></output></div></div>';
    };
    root.innerHTML =
      '<form class="ms-calc__ask" novalidate>' +
        (rounds.length > 1 ? '<fieldset class="ms-calc__q"><legend><b>' + esc(T.qRound) + '</b></legend><div class="ms-calc__opts">' + rounds.map(function (r) { return pill('ch', r.k, r.name, r.c); }).join('') + '</div><p class="ms-calc__note" data-note hidden>' + esc(T.noteMtbTrail) + '</p></fieldset>' : '') +
        '<fieldset class="ms-calc__q"><legend><b>' + esc(T.qDrive) + '</b></legend><div class="ms-calc__opts">' + pill('drive', 'a', T.driveA) + pill('drive', 'e', T.driveE) + '</div></fieldset>' +
        range('hours', T.qHoursB, T.qHours, 0, 12, 0.5) + range('hmw', T.qHmwB, T.qHmw, 0, 4000, 100) + range('long', T.qLongB, T.qLong, 1, 10, 0.5) +
        '<fieldset class="ms-calc__q"><legend><b>' + esc(T.qMultiB) + '</b> ' + esc(T.qMulti) + '</legend><div class="ms-calc__opts">' + pill('multi', 'a', T.multiA) + pill('multi', 'b', T.multiB) + pill('multi', 'c', T.multiC) + '</div></fieldset>' +
        '<fieldset class="ms-calc__q"><legend><b>' + esc(T.qWantB) + '</b> ' + esc(T.qWant) + '</legend><div class="ms-calc__opts">' + pill('want', 'a', T.wantA) + pill('want', 'b', T.wantB) + pill('want', 'c', T.wantC) + '</div></fieldset>' +
      '</form>' +
      '<div class="ms-calc__out" aria-live="polite">' +
        '<span class="ms-calc__kick" data-k></span><p class="ms-calc__tier" data-tier></p><p class="ms-calc__lead" data-lead></p>' +
        '<ul class="ms-calc__bars">' + tiers.map(function (t) { return '<li class="ms-calc__bar" data-bar="' + t.k + '" style="--mc-bc:' + t.c + '"><span class="ms-calc__bar-n"><i></i>' + esc(t.name) + '</span><span class="ms-calc__bar-t"><b></b></span><span class="ms-calc__bar-s"></span></li>'; }).join('') + '</ul>' +
        '<p class="ms-calc__hint" data-hint hidden></p>' +
        '<div class="ms-calc__cta">' + (mode === 'pdp' ? '<button type="button" class="ms-calc__btn" data-cta></button>' : '<a class="ms-calc__btn" data-cta></a>') + '</div>' +
        '<p class="ms-calc__fine">' + esc(T.fine) + '</p>' +
      '</div>';
    root.querySelector('form').addEventListener('submit', function (e) { e.preventDefault(); });

    /* Fuehrung: jede Frage liegt in einer Huelle, die auf- und zuklappen kann. */
    var out = root.querySelector('.ms-calc__out');
    var reduce = function () { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; };
    var steps = Array.prototype.map.call(root.querySelectorAll('.ms-calc__ask > .ms-calc__q'), function (qEl, i) {
      var wrap = document.createElement('div'), inner = document.createElement('div');
      wrap.className = 'ms-calc__step'; inner.className = 'ms-calc__stepin';
      qEl.parentNode.insertBefore(wrap, qEl); inner.appendChild(qEl); wrap.appendChild(inner);
      wrap._i = i; return wrap;
    });
    /* Die Runde ist auf der Buchen-Seite vorbelegt, dort ist die zweite Frage gleich offen. */
    var reached = rounds.length > 1 ? 1 : 0, done = false;
    function guide(scroll) {
      steps.forEach(function (w, i) {
        var wait = i > reached, was = w.classList.contains('is-wait') || !w._seen;
        w.classList.toggle('is-wait', wait); w.inert = wait; w._seen = true;
        if (!wait && was) { clearTimeout(w._t); w.classList.remove('is-in'); w._t = setTimeout(function () { w.classList.add('is-in'); }, reduce() ? 0 : 560); }
      });
      if (!scroll) return;
      var target = steps[Math.min(reached, steps.length - 1)];
      setTimeout(function () { if (target && target.scrollIntoView) target.scrollIntoView({ block: 'nearest', behavior: reduce() ? 'auto' : 'smooth' }); }, reduce() ? 0 : 260);
    }
    function advance(from) {
      if (done || from !== reached) return;
      reached = from + 1; if (reached >= steps.length) { reached = steps.length; done = true; }
      guide(true);
    }

    var q = function (s) { return root.querySelector(s); }, last = null;
    function calc() {
      var ch = byK(st.ch), e = st.drive === 'e', f = FACTOR[ch.k];
      var base = (1.4 * st.hours + 1.25 * st.long) * 20;
      var rows = tiers.map(function (t) {
        var kmDay = ch.km / t.days, hmDay = ch.hm / t.days, need = (kmDay + hmDay / 100) * f * (e ? EBIKE : 1);
        var cf = e ? 1 : 0.88 + 0.12 * Math.min(1, st.hmw / t.hmw);
        if (st.hours >= 7) cf = Math.max(cf, 0.96);
        var k = t.tf * cf * (t.days > 1 ? MULTI[st.multi] : 1);
        var raw = base * k / need, r = raw * WANT[st.want];
        /* Was fehlt bis zur Stufe: erst ueber die laengste Ausfahrt (bis 8 Stunden), sonst ueber die Wochenstunden */
        var ziel = need / (20 * k * WANT[st.want]);
        return { t: t, kmDay: kmDay, hmDay: hmDay, r: r, raw: raw, needLong: (ziel - 1.4 * st.hours) / 1.25, needHours: (ziel - 1.25 * st.long) / 1.4 };
      });
      var pick = function (key) {
        var fit = rows.filter(function (x) { return x[key] >= 1; }), near = rows.filter(function (x) { return x[key] >= 0.8; });
        return fit.length ? fit[fit.length - 1] : (near.length ? near[near.length - 1] : rows[0]);
      };
      var weg = function (x) { return x.needLong <= 8 ? fill(T.wayLong, { h: hrs(Math.max(x.needLong, st.long + 0.5)) }) : fill(T.wayHours, { h: hrs(x.needHours) }); };
      var rec = pick('r'), plain = pick('raw'), idx = rows.indexOf(rec), pIdx = rows.indexOf(plain), hint = '', kick = T.kickNow;
      if (rec.r < 1) {
        kick = rec.r >= 0.8 ? T.kickNear : T.kickStart;
        hint = rec.r >= 0.8 ? fill(T.hintNear, { tier: rec.t.name, way: weg(rec) }) : fill(T.hintStart, { way: weg(rec) });
      } else if (st.want === 'a' && pIdx > idx) {
        kick = T.kickRec; hint = fill(T.hintScenery, { plain: plain.t.name, tier: rec.t.name, claim: rec.t.claim });
      } else if (st.want === 'c' && idx > pIdx) {
        kick = T.kickRec; hint = fill(T.hintLimit, { tier: rec.t.name, plain: plain.t.name });
      } else if (idx < 2 && rows[idx + 1].r >= 0.8) {
        hint = fill(T.hintUp, { tier: rows[idx + 1].t.name, way: weg(rows[idx + 1]) });
      } else if (st.want === 'c' && idx < 2 && rows[idx + 1].r >= 0.55) {
        hint = fill(T.hintFar, { tier: rows[idx + 1].t.name, way: weg(rows[idx + 1]) });
      }
      if (!hint && e) hint = T.hintEbike;
      return { ch: ch, rows: rows, rec: rec, hint: hint, kick: kick };
    }
    function paint() {
      var R = calc(), rec = R.rec; last = R;
      out.style.setProperty('--mc-tc', rec.t.c);
      q('[data-k]').textContent = R.kick;
      q('[data-tier]').textContent = rec.t.name;
      q('[data-lead]').innerHTML = esc(fill(st.drive === 'e' ? T.leadE : T.lead, { name: R.ch.name, trip: rec.t.trip })) +
        '<span>' + esc(fill(T.leadDay, { km: nf(Math.round(rec.kmDay / 5) * 5), hm: nf(Math.round(rec.hmDay / 10) * 10) })) + ' ' + esc(rec.t.claim) + '</span>';
      var note = q('[data-note]'); if (note) note.hidden = !(st.ch === 'mtb' || st.ch === 'trail');
      R.rows.forEach(function (x) {
        var li = q('[data-bar="' + x.t.k + '"]');
        li.classList.toggle('is-rec', x === rec);
        li.querySelector('b').style.width = Math.min(100, x.r / 1.5 * 100).toFixed(1) + '%';
        li.querySelector('.ms-calc__bar-s').textContent = x.r >= 1 ? T.statusFit : (x.r >= 0.8 ? T.statusPrep : T.statusEarly);
      });
      var h = q('[data-hint]'); h.hidden = !R.hint; h.textContent = R.hint;
      var a = q('[data-cta]');
      if (mode === 'pdp') a.innerHTML = esc(fill(T.ctaPick, { tier: rec.t.name })) + ARROW;
      else { a.href = R.ch.url || '#'; a.innerHTML = esc(fill(T.ctaView, { name: R.ch.name, tier: rec.t.name })) + ARROW; }
      q('[data-o="hours"]').textContent = hrs(st.hours);
      q('[data-o="long"]').textContent = hrs(st.long);
      q('[data-o="hmw"]').textContent = st.hmw >= 4000 ? T.hmMax : fill(T.hm, { n: nf(st.hmw) });
    }
    root.addEventListener('input', function (e) {
      var t = e.target; if (!t.name || t.name.indexOf(id + '-') !== 0) return;
      var key = t.name.slice(id.length + 1);
      st[key] = (key === 'long' || key === 'hours' || key === 'hmw') ? parseFloat(t.value) : t.value; answered[key] = true;
      paint();
    });
    var stepOf = function (el) { var w = el.closest('.ms-calc__step'); return w ? w._i : -1; };
    /* Die erste Beruehrung zaehlt: Regler bewegen oder Pille waehlen (click, damit auch eine
       aus der Bike-Wahl vorbelegte Pille bestaetigt werden kann). */
    root.addEventListener('input', function (e) { if (e.target.type === 'range') advance(stepOf(e.target)); });
    root.addEventListener('click', function (e) {
      var opt = e.target.closest('.ms-calc__opt input'); if (!opt) return;
      var i = stepOf(opt); setTimeout(function () { advance(i); }, reduce() ? 0 : 160);
    });
    root.addEventListener('click', function (e) {
      if (mode !== 'pdp' || !e.target.closest('[data-cta]') || !last) return;
      host.dispatchEvent(new CustomEvent('ms:calc-pick', { bubbles: true, detail: { tier: last.rec.t.k, index: tiers.indexOf(last.rec.t) + 1 } }));
    });
    var setRadio = function (name, val) { var i = root.querySelector('#' + id + '-' + name + '-' + val); if (i) i.checked = true; };
    paint(); guide(false);
    host._msCalc = {
      setRound: function (k) { if (st.ch === k || !rounds.some(function (r) { return r.k === k; })) return; st.ch = k; setRadio('ch', k); paint(); },
      /* Der Antrieb aus der Bike-Wahl gilt als beantwortet und oeffnet die naechste Frage. */
      setDrive: function (v) { if (v !== 'a' && v !== 'e') return; st.drive = v; answered.drive = true; setRadio('drive', v); paint(); var i = root.querySelector('#' + id + '-drive-' + v); if (i) advance(stepOf(i)); }
    };
    return host._msCalc;
  }

  /* Fenster auf der Produktseite. Der Einstieg [data-ms-calc-open] steht neben "Deine
     Herausforderung"; beim Oeffnen uebernimmt der Rechner den gewaehlten Antrieb, der Knopf im
     Ergebnis setzt die Stufe auf der Seite. */
  function popup(pop) {
    if (pop._msReady) return; pop._msReady = true;
    /* Wird die Section neu gezeichnet, haengt sich ein zweites Fenster an body: das alte gewinnt. */
    var twins = document.querySelectorAll('modal-dialog[id="' + pop.id + '"]');
    if (twins.length > 1 && twins[0] !== pop) { pop.remove(); return; }
    var api = mount(pop.querySelector('[data-ms-calc]')), closeT = 0;
    new MutationObserver(function () {
      clearTimeout(closeT);
      if (pop.hasAttribute('open')) {
        pop.classList.remove('is-closing'); pop.classList.add('is-on');
        requestAnimationFrame(function () { requestAnimationFrame(function () {
          pop.classList.add('is-open');
          /* Fokus erst jetzt ins Fenster: beim show() war es noch unsichtbar, der Fokus blieb
             dahinter auf der Seite, und Escape (keyup am Fenster) kam nie an. */
          var dlg = pop.querySelector('[role="dialog"]') || pop;
          if (typeof window.trapFocus === 'function') window.trapFocus(pop, dlg);
          else { dlg.setAttribute('tabindex', '-1'); dlg.focus({ preventScroll: true }); }
        }); });
      } else if (pop.classList.contains('is-on')) {
        pop.classList.remove('is-open'); pop.classList.add('is-closing');
        closeT = setTimeout(function () { pop.classList.remove('is-on', 'is-closing'); }, 540);
      }
    }).observe(pop, { attributes: true, attributeFilter: ['open'] });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && pop.hasAttribute('open') && typeof pop.hide === 'function') pop.hide();
    });
    pop.addEventListener('ms:calc-pick', function (e) {
      var sec = document.getElementById('shopify-section-' + pop.getAttribute('data-ms-calc-section')) || document;
      var input = sec.querySelector('input[type="radio"][data-ms-tier="' + e.detail.index + '"]');
      if (typeof pop.hide === 'function') pop.hide();
      if (!input) return;
      /* Ist die Stufe noch gesperrt (kein Bike gewaehlt), bleibt es beim Hinweis im Fenster. */
      var locked = input.closest('fieldset.ms-locked');
      if (!locked && !input.checked) input.click();
      var card = sec.querySelector('label[data-ms-tier="' + e.detail.index + '"]');
      if (card && card.scrollIntoView) setTimeout(function () { card.scrollIntoView({ block: 'center', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' }); }, 320);
    });
    pop._msCalcApi = api;
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ms-calc-open]'); if (!btn) return;
    var pop = document.getElementById(btn.getAttribute('data-ms-calc-open')); if (!pop || typeof pop.show !== 'function') return;
    e.preventDefault(); popup(pop);
    /* Antrieb aus der Bike-Wahl: der zweite Wert der ersten Option ist das E-Bike. */
    var sec = btn.closest('.shopify-section') || document, bikes = sec.querySelectorAll('.ms-bikecard'), pick = '';
    Array.prototype.forEach.call(bikes, function (l, i) { var inp = document.getElementById(l.getAttribute('for')); if (inp && inp.checked) pick = i === 1 ? 'e' : 'a'; });
    /* Ohne Bike-Wahl bleibt die Frage leer. */
    if (pop._msCalcApi && pick) pop._msCalcApi.setDrive(pick);
    pop.show(btn);
  });

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-ms-calc]'), function (h) { if (!h.closest('modal-dialog')) mount(h); });
    Array.prototype.forEach.call(document.querySelectorAll('modal-dialog[data-ms-calc-pop]'), popup);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  window.MSTierCalc = { mount: mount };
})();
